const resultsList = document.querySelector('results-list[infinite-scroll="true"]');

if (resultsList) {
  let refreshScheduled = false;
  let fullRefreshRequested = false;
  const pendingCards = new Set();
  const cardSelector = '.product-grid__item';
  const renderedColorsByProduct = new Map();

  const rememberRenderedColors = (card) => {
    const productId = card.dataset.linkifyProduct;
    const colors = card.querySelector('webyze-linkify-product-colors');

    if (productId && colors) renderedColorsByProduct.set(productId, colors);
  };

  const refreshLinkify = (cards, restoreCachedColors = false) => {
    const anchors = [];

    for (const card of cards) {
      if (restoreCachedColors) {
        rememberRenderedColors(card);

        const anchor = card.querySelector('webyze-product-colors-anchor[data-product]');
        const productId = anchor?.dataset.product;
        const colors = productId && renderedColorsByProduct.get(productId);

        if (anchor && colors) {
          card.removeAttribute('data-linkify-pc');
          anchor.insertAdjacentElement('afterend', colors);
          anchor.remove();
          continue;
        }

        if (anchor) {
          card.removeAttribute('data-linkify-pc');
          anchor.removeAttribute('data-linkify-queued');
        }
      }

      anchors.push(
        ...card.querySelectorAll('webyze-product-colors-anchor[data-product]:not([data-linkify-queued])'),
      );
    }

    if (!anchors.length) return;

    window.webyzeProductColorsQueue = window.webyzeProductColorsQueue || [];

    for (const anchor of anchors) {
      const productId = Number(anchor.dataset.product);

      if (!Number.isSafeInteger(productId)) continue;

      anchor.closest(cardSelector)?.setAttribute('data-linkify-product', String(productId));
      anchor.setAttribute('data-linkify-queued', '');
      window.webyzeProductColorsQueue.push({
        productId,
        shopDomain: anchor.dataset.shopDomain || window.Shopify?.shop,
      });
    }
  };

  const scheduleRefresh = () => {
    if (refreshScheduled) return;

    refreshScheduled = true;
    requestAnimationFrame(() => {
      refreshScheduled = false;

      if (fullRefreshRequested) {
        fullRefreshRequested = false;
        refreshLinkify([...grid.querySelectorAll(cardSelector)], true);
        pendingCards.clear();
        return;
      }

      if (!pendingCards.size) return;
      refreshLinkify([...pendingCards]);
      pendingCards.clear();
    });
  };

  const scheduleFullRefresh = () => {
    grid.querySelectorAll(cardSelector).forEach(rememberRenderedColors);
    fullRefreshRequested = true;
  };

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (!(node instanceof Element)) continue;

        const card = node.matches(cardSelector)
          ? node
          : node.closest(cardSelector);

        if (card) {
          rememberRenderedColors(card);
          pendingCards.add(card);
        }
      }
    }

    if (pendingCards.size || fullRefreshRequested) scheduleRefresh();
  });

  const grid = resultsList.querySelector('[ref="grid"]');

  if (grid) {
    refreshLinkify([...grid.querySelectorAll(`:scope > ${cardSelector}`)]);
    observer.observe(grid, {
      attributes: true,
      attributeFilter: ['data-last-page'],
      childList: true,
      subtree: true,
    });
    document.addEventListener('filter:update', scheduleFullRefresh);
  }
}
